import React from 'react'

import { cn } from '@/lib/utils'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

// Fallback tints, picked by a stable key so the same person keeps their
// colour and a list of initials does not read as one person. Literal
// classes for Tailwind.
const TINTS = [
    'bg-sky-100 text-sky-800 dark:bg-sky-500/20 dark:text-sky-200',
    'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-200',
    'bg-violet-100 text-violet-800 dark:bg-violet-500/20 dark:text-violet-200',
    'bg-rose-100 text-rose-800 dark:bg-rose-500/20 dark:text-rose-200',
    'bg-amber-100 text-amber-900 dark:bg-amber-500/20 dark:text-amber-200',
    'bg-teal-100 text-teal-800 dark:bg-teal-500/20 dark:text-teal-200'
]

function tint(key: string): string {
    let hash = 0
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0
    }
    return TINTS[Math.abs(hash) % TINTS.length]
}

// Avatar with the first letter of the name as fallback. `coach` adds the
// amber ring that marks coaches and other premium authors; className can
// override its width and offset. `tintKey` (a user id) colours the
// fallback, for lists of many initials.
const UserAvatar: React.FC<{
    name?: string
    photo?: string
    coach?: boolean
    tintKey?: string
    className?: string
    fallbackClassName?: string
}> = ({ name, photo, coach, tintKey, className, fallbackClassName }) => (
    <Avatar
        className={cn(
            coach &&
                'ring-2 ring-amber-400 ring-offset-1 ring-offset-background',
            className
        )}
    >
        <AvatarImage src={photo || undefined} alt={name} />
        <AvatarFallback
            className={cn(tintKey && tint(tintKey), fallbackClassName)}
        >
            {name?.charAt(0).toUpperCase() || '?'}
        </AvatarFallback>
    </Avatar>
)

export default UserAvatar
